import { InnerContent } from '@/components/atoms/InnerContent/InnerContent';

interface SpecialismsProps {
  specialisms: string[];
}
export const Specialisms = ({ specialisms }: SpecialismsProps) => {
  return (
    <InnerContent
      size='sm'
      items={specialisms.map((specialism) => ({
        description: specialism,
        icon: 'check',
        iconSize: '1x',
      }))}
    />
  );
};

export default Specialisms;
